<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="视频标题" prop="name">
                <el-input v-model="form.name" placeholder="请输入标题" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="seo关键词" prop="keyword">
                <DynamicTag v-model="keyword" @change="handleTagChange"></DynamicTag>
            </el-form-item>
            <el-form-item label="副标题" prop="sub_name">
                <el-input v-model="form.sub_name" placeholder="请输入副标题" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="选择分类" prop="category_uuid">
                <VideoCategory v-model="form.category_uuid" style="width: 300px"></VideoCategory>
            </el-form-item>
            <el-form-item label="视频描述" prop="desc">
                <el-input :rows="5" type="textarea" v-model="form.desc" placeholder="请输入视频描述"></el-input>
            </el-form-item>
            <el-form-item label="上传视频" prop="url">
                <Uploader type="video" v-model="form.url" tip="只能上传mp4格式文件">选择上传文件</Uploader>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
                <el-button style="width: 120px" type="primary" @click="handleConfirm">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import DynamicTag from "@/components/DynamicTag";
import VideoCategory from "@/components/VideoCategory";
import Uploader from "@/components/Uploader";
import { add, edit, detail } from "@/api/video/list";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Language, DynamicTag, VideoCategory, Uploader },
    data() {
        return {
            form: {
                keyword: "",
                lang: "zh",
            },
            keyword: [],
            rules: {
                name: [{ required: true, message: "请输入标题" }],
                keyword: [{ required: true, message: "请输入seo关键词" }],
                sub_name: [{ required: true, message: "请输入副标题" }],
                category_uuid: [{ required: true, message: "请选择分类" }],
                url: [{ required: true, message: "请上传视频" }],
            },
            cuuid: "",
            isEdit: false,
            add: true,
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        if (this.form.cuuid) {
            this.add = false;
            this.isEdit = true;
            this.getDetail();
        } else {
            this.add = true;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.cuuid = result.cuuid;
                        this.form.keyword = result.keyword ? result.keyword.split(",") : [];
                        this.keyword = this.form.keyword;
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid };
                        this.cuuid = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleTagChange(value) {
            if (value && value.length > 0) {
                this.form.keyword = value;
            } else {
                this.form.keyword = "";
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    keyword: this.form.keyword ? this.form.keyword.join() : "",
                };
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("修改成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
